import React from 'react';

export interface TrackProps {
	className: string;
	vertical: boolean;
	percentage: number;
}

export default function Track({ className, vertical, percentage }: TrackProps) {
	let style;

	if (vertical) {
		style = { height: `${percentage}%`, bottom: 0 };
	} else {
		style = { width: `${percentage}%` };
	}

	return (
		<div
			className={className}
			style={style}
		/>
	);
}
